import { render, staticRenderFns } from "./YButton.vue?vue&type=template&id=43ae9b69&scoped=true"
import script from "./YButton.vue?vue&type=script&lang=js"
export * from "./YButton.vue?vue&type=script&lang=js"
import style0 from "./YButton.vue?vue&type=style&index=0&id=43ae9b69&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae9b69",
  null
  
)

export default component.exports